<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>APP首页模块配置</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="app_module_id"
                         label="模块id"></el-table-column>
        <el-table-column prop="admin_name"
                         label="管理员姓名"></el-table-column>
        <el-table-column prop="desc"
                         label="详情"></el-table-column>
        <el-table-column prop="updated_at"
                         label="创建时间"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      id: this.$route.query.id,
      // 表格数据
      table: [],
    }
  },
  computed: Vuex.mapState({}),
  created () {

  },
  methods: {
    ...Vuex.mapActions({}),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getModuleOperateLog', {...params, id: this.id})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformHomeModuleLogTable.vue